function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import { ReductionStatuses } from "../../enum/ReductionStatuses";
import { ReductionTypes } from "../../enum/ReductionTypes";
import { StreamingStatuses } from "../../enum/StreamingStatuses";
/**
 * 会議素材情報　モデル
 */

var SessionMaterialInstanceModel =
/**
 * コンストラクタ
 *
 */
function SessionMaterialInstanceModel() {
  _classCallCheck(this, SessionMaterialInstanceModel);

  this.MaterialFileName = "";
  this.DisplayFileName = "";
  this.DisplayMaterialFileName = "";
  this.DisplayOptions = 0;
  this.IsShare = false;
  this.MaterialFileExtension = "";
  this.StickyNoteCount = 0;
  this.LastModified = new Date();
  this.Type = ReductionTypes.Model;
  this.Status = ReductionStatuses.Untreated;
  this.StreamingStatus = StreamingStatuses.Offline;
  this.StreamingUrl = "";
  this.MaterialFileSize = 0;
  this.ReductionMaterialFileSize = undefined;
  this.ReductionRate = undefined;
  this.IsTerrain = false;
  this.IsStream = false;
  this.IsFeel = false;
  this.Is3D = false;
  this.UploadMaterialsItemNames = null;
  this.UploadState = undefined;
};

export { SessionMaterialInstanceModel as default };